"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patreon = void 0;
var types_1 = require("../types");
exports.patreon = {
    name: 'patreon',
    matches: [
        {
            match: '(https?://)?(www.)?patreon.com/({PROFILE_ID})/?', group: 3, type: types_1.TYPE_DESKTOP,
            pattern: 'https://patreon.com/{PROFILE_ID}'
        },
        { match: '({PROFILE_ID})', group: 1 },
    ]
};
